import React from "react";
import "./component.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const CreateCorporateComponent = (props) => {
  return (
    <div className="bp-form-row">
      <div className="bp-form-column">
        <TextField
          className="bp-form-field"
          fullWidth
          label="Corporate Name *"
          name="name"
          value={props.createCorporateData.name}
          onChange={props.handleChangeCorporate}
        />
        
        <TextField
          className="bp-form-field"
          fullWidth
          label="Domain *"
          name="domain"
          value={props.createCorporateData.domains[0].domain}
          onChange={props.handleChangeCorporate}
        />

        <TextField
          className="bp-form-field"
          fullWidth
          label="Initial Balance *"
          name="initial_balance"
          value={props.createCorporateData.domains[0]?.initial_balance || ""}
          onChange={(e) => {
            const { name, value } = e.target;
            props.setCreateCorporateData((prevData) => ({
              ...prevData,
              domains: [
                {
                  ...prevData.domains[0],
                  [name]: value,
                },
              ],
            }));
          }}
        />
        <TextField
          className="bp-form-field"
          fullWidth
          label="Auto Expiry Month"
          name="expiry_date_month"
          value={props.createCorporateData.expiry_date_month}
          onChange={props.handleChangeCorporate}
        />
      </div>
    </div>
  );
};

export default CreateCorporateComponent;